<template>
  <div>
    <section class="eva_report d-flex justify-content-center align-items-center">
      <div class="container px-lg-0">
        <div class="row">
          <div class="col-md-12">
            <div class="give_para text-center mt_10 frame_h">
              <div style="position: relative; height: 100%" id="htmlTest"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import commonFunction from "../../mixin/commonFunction";
export default {
  name: "new_evaluation",
  mixins: [commonFunction],
  beforeMount() {
    let res = this.$store.dispatch("auth/getAuthUser");
    res.then((value) => {
      let userPermissions = value.user.roles.all_permission;
      let client_list = userPermissions.includes("evaluator-client-list");
      console.log("bbbb : ", client_list);
      if (client_list == false) {
        this.$toast.error(
          "You do not have permission to start new evaluation",
          {
            position: "top-right",
            duration: 5000,
          }
        );
        this.$router.push({ name: "403" });
      }
    });
  },
  mounted() {
    document.title = "PBErgo - " + this.$router.currentRoute.meta.page_title;
    // document.body.classList.add("viewreporthidden");
    document.body.classList.add("fix-header");
   
    this.getNewEvaluationLink();
  },
  data() {
    return {
      url_data: "",
      // url_data: 'https://survey.alchemer.com/s3/6916070/Ergo-Eval',
    };
  },
  methods: {
    getNewEvaluationLink() {
      var _this = this;
      var cid = _this.$route.params.cid;
      var uid = _this.$route.params.uid;
      console.log("cid", cid);
      let config = {
        method: "get",
        url:
          process.env.VUE_APP_API_URL +
          "/api/get-client-ergo-eval-link/" +
          cid +
          "/" +
          uid,
        withCredentials: true,
      };
      _this
        .axios(config)
        .then(({ data }) => {
          var decodedJson = _this.decodeAPIResponse(data.data);
          _this.url_data = decodedJson.ergo_eval_url;
          // Create a blob Url for hiding iframe src
          var blobMe = URL["createObjectURL"](
            new Blob([""], { type: "text/html" })
          );
          var elIframe = document["createElement"]("iframe");
          elIframe["setAttribute"]("frameborder", "0");
          elIframe["setAttribute"]("width", "100%");
          elIframe["setAttribute"]("height", "100%");
          elIframe["setAttribute"]("allowfullscreen", "true");
          elIframe["setAttribute"]("webkitallowfullscreen", "true");
          elIframe["setAttribute"]("mozallowfullscreen", "true");
          elIframe["setAttribute"](
            "style",
            "position: relative; top: 0; left: 0;"
          );
          elIframe["setAttribute"]("src", blobMe);
          var idOne = "gepa_" + Date.now();
          elIframe["setAttribute"]("id", idOne);
          document.getElementById("htmlTest").appendChild(elIframe);
          const iframeHere = _this.url_data;
          document["getElementById"](idOne)["contentWindow"]["document"].write(
            '<script type="text/javascript">location.href = "' +
            iframeHere +
            '";\x3c/script>'
          );
        })
        .catch(({ response }) => {
          if (response.status == 404) {
            this.$router.push({ name: "404" });
          }
          if (response.status == 401) {
            this.tokenExpired();
            this.$router.push({ name: "login" });
          }
          if (response.status == 403) {
            this.$toast.error(
              "You do not have permission to start new evaluation",
              {
                position: "top-right",
                duration: 5000,
              }
            );
            this.$router.push({ name: "403" });
          }
        });
    },
  },
};
</script>
